import { isCrmCoreRole } from '@crm/shared'
import { useAuthStore } from '../auth/authStore'

/**
 * Открывается ли роли «Очередь квот» — одно правило для гейта раздела
 * (QueueRouteGuard) и для ссылок в очередь с других экранов.
 *
 * С 18.09.2026 раздел закрыт для ADMIN (решение Сергея, п. 11 встречи 17.09).
 * 25.09.2026 у админа убраны и ссылки в очередь (решение Сергея) — раньше они
 * вели на заглушку «Раздел недоступен»: «Дашборд РОЗ» (кнопка «К очереди» и
 * клики по плиткам, воронке, «Текучке / Проектам», таблице закупщиков),
 * хлебная крошка «Очередь» на странице позиции, ссылка в пустом списке
 * «Запросов поставщикам».
 */
export function canOpenQueue(role: string | null | undefined): boolean {
  return isCrmCoreRole(role ?? '') && role !== 'ADMIN'
}

/** `canOpenQueue` для текущего пользователя. */
export function useCanOpenQueue(): boolean {
  const { user } = useAuthStore()
  return canOpenQueue(user?.role)
}
